import { render, staticRenderFns } from "./QuickAction.vue?vue&type=template&id=59983574"
import script from "./QuickAction.vue?vue&type=script&lang=js"
export * from "./QuickAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports